import db from "../db";
async function SetData(areas) {
  let dbAreas = await db.table("areas").toArray();
  var data = areas.map((info, index) => {
    let dataObj = {
      objectid: info.properties.objectid,
      user_count: info.properties.userCount,
      male_count: info.properties.maleCount,
      female_count: info.properties.femaleCount,
      revenue: info.properties.revenue,
      info: info,
    };
    return dataObj;
  });
  if (dbAreas.length > 0) {
    // db.areas.bulkPut(data).then((res) => {
    //   console.log(res);
    // });
  } else {
    db.areas.bulkAdd(data).then((res) => {
      // console.log(res);
    });
  }
}

async function getMaxRevData(count) {
  let data = await db.areas.orderBy("revenue").reverse().toArray();
  let SlicedData = data;
  // console.log(SlicedData);
  return SlicedData;
}

async function getCampaign() {
  let data = await db.areas.orderBy("user_count").toArray();
  return data;
}

async function getRatioOff(params) {
  let data = await db.areas.orderBy("user_count").toArray();
  let filterdData = data.filter((info, index) => {
    // console.log(info);
    let malePercentage = Math.round((info.male_count / info.user_count) * 100);
    let femalePercentage = Math.round(
      (info.female_count / info.user_count) * 100
    );
    // console.log(malePercentage, femalePercentage);
    if (malePercentage <= 30 || femalePercentage <= 30) {
      return true;
    }
  });

  return filterdData;
}

async function getData(params) {
  let dbAreas = await db.table("areas").toArray();
  let Areas = dbAreas.map((info) => {
    return info.info;
  });
  return Areas;
}

async function getMaxUsers(params) {
  let data = await db.areas.orderBy("user_count").reverse().toArray();
  let Areas = data.map((info) => {
    return info.info;
  });
  return Areas;
}
async function getMaxFemale(params) {
  let data = await db.areas.orderBy("female_count").reverse().toArray();
  let Areas = data.map((info) => {
    return info.info;
  });
  return Areas;
}
async function getMaxMale(params) {
  let data = await db.areas.orderBy("male_count").reverse().toArray();
  let Areas = data.map((info) => {
    return info.info;
  });
  return Areas;
}

export {
  SetData,
  getMaxRevData,
  getCampaign,
  getRatioOff,
  getData,
  getMaxUsers,
  getMaxFemale,
  getMaxMale,
};
